export const types = {
    FETCH_REQUEST: 'OFFER_DETAIL_FETCH_REQUEST',
    FETCH_SUCCESS: 'OFFER_DETAIL_FETCH_SUCCESS',
    FETCH_FAILURE: 'OFFER_DETAIL_FETCH_FAILURE',

    CLEANUP: 'OFFER_DETAIL_CLEANUP',
}